import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-content-modal',
  templateUrl: './content-modal.component.html',
  styleUrls: ['./content-modal.component.scss'],
})
export class ContentModalComponent {
  title: string = '';
  content: string = '';
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { title: string; content: string },
  ) {
    if (data) {
      this.title = data.title;
      this.content = data.content;
    }
  }
}
